export interface CountryListItem {
    country: string;
    cca2: string;
    cca3: string;
    ccn3: number;
}

export const CountriesList: CountryListItem[] = [
    {
        country: 'United States',
        cca2: 'US',
        cca3: 'USA',
        ccn3: 840
    },
    {
        country: 'Afghanistan',
        cca2: 'AF',
        cca3: 'AFG',
        ccn3: 4
    },
    {
        country: 'Albania',
        cca2: 'AL',
        cca3: 'ALB',
        ccn3: 8
    },
    {
        country: 'Algeria',
        cca2: 'DZ',
        cca3: 'DZA',
        ccn3: 12
    },
    {
        country: 'American Samoa',
        cca2: 'AS',
        cca3: 'ASM',
        ccn3: 16
    },
    {
        country: 'Andorra',
        cca2: 'AD',
        cca3: 'AND',
        ccn3: 20
    },
    {
        country: 'Angola',
        cca2: 'AO',
        cca3: 'AGO',
        ccn3: 24
    },
    {
        country: 'Anguilla',
        cca2: 'AI',
        cca3: 'AIA',
        ccn3: 660
    },
    {
        country: 'Antigua and Barbuda',
        cca2: 'AG',
        cca3: 'ATG',
        ccn3: 28
    },
    {
        country: 'Argentina',
        cca2: 'AR',
        cca3: 'ARG',
        ccn3: 32
    },
    {
        country: 'Armenia',
        cca2: 'AM',
        cca3: 'ARM',
        ccn3: 51
    },
    {
        country: 'Aruba',
        cca2: 'AW',
        cca3: 'ABW',
        ccn3: 533
    },
    {
        country: 'Australia',
        cca2: 'AU',
        cca3: 'AUS',
        ccn3: 36
    },
    {
        country: 'Austria',
        cca2: 'AT',
        cca3: 'AUT',
        ccn3: 40
    },
    {
        country: 'Azerbaijan',
        cca2: 'AZ',
        cca3: 'AZE',
        ccn3: 31
    },
    {
        country: 'Bahamas',
        cca2: 'BS',
        cca3: 'BHS',
        ccn3: 44
    },
    {
        country: 'Bahrain',
        cca2: 'BH',
        cca3: 'BHR',
        ccn3: 48
    },
    {
        country: 'Bangladesh',
        cca2: 'BD',
        cca3: 'BGD',
        ccn3: 50
    },
    {
        country: 'Barbados',
        cca2: 'BB',
        cca3: 'BRB',
        ccn3: 52
    },
    {
        country: 'Belarus',
        cca2: 'BY',
        cca3: 'BLR',
        ccn3: 112
    },
    {
        country: 'Belgium',
        cca2: 'BE',
        cca3: 'BEL',
        ccn3: 56
    },
    {
        country: 'Belize',
        cca2: 'BZ',
        cca3: 'BLZ',
        ccn3: 84
    },
    {
        country: 'Benin',
        cca2: 'BJ',
        cca3: 'BEN',
        ccn3: 204
    },
    {
        country: 'Bermuda',
        cca2: 'BM',
        cca3: 'BMU',
        ccn3: 60
    },
    {
        country: 'Bhutan',
        cca2: 'BT',
        cca3: 'BTN',
        ccn3: 64
    },
    {
        country: 'Bolivia',
        cca2: 'BO',
        cca3: 'BOL',
        ccn3: 68
    },
    {
        country: 'Bosnia and Herzegovina',
        cca2: 'BA',
        cca3: 'BIH',
        ccn3: 70
    },
    {
        country: 'Botswana',
        cca2: 'BW',
        cca3: 'BWA',
        ccn3: 72
    },
    {
        country: 'Brazil',
        cca2: 'BR',
        cca3: 'BRA',
        ccn3: 76
    },
    {
        country: 'British Virgin Islands',
        cca2: 'VG',
        cca3: 'VGB',
        ccn3: 92
    },
    {
        country: 'Brunei',
        cca2: 'BN',
        cca3: 'BRN',
        ccn3: 96
    },
    {
        country: 'Bulgaria',
        cca2: 'BG',
        cca3: 'BGR',
        ccn3: 100
    },
    {
        country: 'Burkina Faso',
        cca2: 'BF',
        cca3: 'BFA',
        ccn3: 854
    },
    {
        country: 'Burundi',
        cca2: 'BI',
        cca3: 'BDI',
        ccn3: 108
    },
    {
        country: 'Cambodia',
        cca2: 'KH',
        cca3: 'KHM',
        ccn3: 116
    },
    {
        country: 'Cameroon',
        cca2: 'CM',
        cca3: 'CMR',
        ccn3: 120
    },
    {
        country: 'Canada',
        cca2: 'CA',
        cca3: 'CAN',
        ccn3: 124
    },
    {
        country: 'Cape Verde',
        cca2: 'CV',
        cca3: 'CPV',
        ccn3: 132
    },
    {
        country: 'Cayman Islands',
        cca2: 'KY',
        cca3: 'CYM',
        ccn3: 136
    },
    {
        country: 'Central African Republic',
        cca2: 'CF',
        cca3: 'CAF',
        ccn3: 140
    },
    {
        country: 'Chad',
        cca2: 'TD',
        cca3: 'TCD',
        ccn3: 148
    },
    {
        country: 'Chile',
        cca2: 'CL',
        cca3: 'CHL',
        ccn3: 152
    },
    {
        country: 'China',
        cca2: 'CN',
        cca3: 'CHN',
        ccn3: 156
    },
    {
        country: 'Colombia',
        cca2: 'CO',
        cca3: 'COL',
        ccn3: 170
    },
    {
        country: 'Comoros',
        cca2: 'KM',
        cca3: 'COM',
        ccn3: 174
    },
    {
        country: 'Cook Islands',
        cca2: 'CK',
        cca3: 'COK',
        ccn3: 184
    },
    {
        country: 'Costa Rica',
        cca2: 'CR',
        cca3: 'CRI',
        ccn3: 188
    },
    {
        country: 'Croatia',
        cca2: 'HR',
        cca3: 'HRV',
        ccn3: 191
    },
    {
        country: 'Cuba',
        cca2: 'CU',
        cca3: 'CUB',
        ccn3: 192
    },
    {
        country: 'Curacao',
        cca2: 'CW',
        cca3: 'CUW',
        ccn3: 531
    },
    {
        country: 'Cyprus',
        cca2: 'CY',
        cca3: 'CYP',
        ccn3: 196
    },
    {
        country: 'Czech Republic',
        cca2: 'CZ',
        cca3: 'CZE',
        ccn3: 203
    },
    {
        country: 'Denmark',
        cca2: 'DK',
        cca3: 'DNK',
        ccn3: 208
    },
    {
        country: 'Djibouti',
        cca2: 'DJ',
        cca3: 'DJI',
        ccn3: 262
    },
    {
        country: 'Dominica',
        cca2: 'DM',
        cca3: 'DMA',
        ccn3: 212
    },
    {
        country: 'Dominican Republic',
        cca2: 'DO',
        cca3: 'DOM',
        ccn3: 214
    },
    {
        country: 'DR Congo',
        cca2: 'CD',
        cca3: 'COD',
        ccn3: 180
    },
    {
        country: 'Ecuador',
        cca2: 'EC',
        cca3: 'ECU',
        ccn3: 218
    },
    {
        country: 'Egypt',
        cca2: 'EG',
        cca3: 'EGY',
        ccn3: 818
    },
    {
        country: 'El Salvador',
        cca2: 'SV',
        cca3: 'SLV',
        ccn3: 222
    },
    {
        country: 'Equatorial Guinea',
        cca2: 'GQ',
        cca3: 'GNQ',
        ccn3: 226
    },
    {
        country: 'Eritrea',
        cca2: 'ER',
        cca3: 'ERI',
        ccn3: 232
    },
    {
        country: 'Estonia',
        cca2: 'EE',
        cca3: 'EST',
        ccn3: 233
    },
    {
        country: 'Eswatini',
        cca2: 'SZ',
        cca3: 'SWZ',
        ccn3: 748
    },
    {
        country: 'Ethiopia',
        cca2: 'ET',
        cca3: 'ETH',
        ccn3: 231
    },
    {
        country: 'Falkland Islands',
        cca2: 'FK',
        cca3: 'FLK',
        ccn3: 238
    },
    {
        country: 'Faroe Islands',
        cca2: 'FO',
        cca3: 'FRO',
        ccn3: 234
    },
    {
        country: 'Fiji',
        cca2: 'FJ',
        cca3: 'FJI',
        ccn3: 242
    },
    {
        country: 'Finland',
        cca2: 'FI',
        cca3: 'FIN',
        ccn3: 246
    },
    {
        country: 'France',
        cca2: 'FR',
        cca3: 'FRA',
        ccn3: 250
    },
    {
        country: 'French Guiana',
        cca2: 'GF',
        cca3: 'GUF',
        ccn3: 254
    },
    {
        country: 'French Polynesia',
        cca2: 'PF',
        cca3: 'PYF',
        ccn3: 258
    },
    {
        country: 'Gabon',
        cca2: 'GA',
        cca3: 'GAB',
        ccn3: 266
    },
    {
        country: 'Gambia',
        cca2: 'GM',
        cca3: 'GMB',
        ccn3: 270
    },
    {
        country: 'Georgia',
        cca2: 'GE',
        cca3: 'GEO',
        ccn3: 268
    },
    {
        country: 'Germany',
        cca2: 'DE',
        cca3: 'DEU',
        ccn3: 276
    },
    {
        country: 'Ghana',
        cca2: 'GH',
        cca3: 'GHA',
        ccn3: 288
    },
    {
        country: 'Gibraltar',
        cca2: 'GI',
        cca3: 'GIB',
        ccn3: 292
    },
    {
        country: 'Greece',
        cca2: 'GR',
        cca3: 'GRC',
        ccn3: 300
    },
    {
        country: 'Greenland',
        cca2: 'GL',
        cca3: 'GRL',
        ccn3: 304
    },
    {
        country: 'Grenada',
        cca2: 'GD',
        cca3: 'GRD',
        ccn3: 308
    },
    {
        country: 'Guadeloupe',
        cca2: 'GP',
        cca3: 'GLP',
        ccn3: 312
    },
    {
        country: 'Guam',
        cca2: 'GU',
        cca3: 'GUM',
        ccn3: 316
    },
    {
        country: 'Guatemala',
        cca2: 'GT',
        cca3: 'GTM',
        ccn3: 320
    },
    {
        country: 'Guinea',
        cca2: 'GN',
        cca3: 'GIN',
        ccn3: 324
    },
    {
        country: 'Guinea-Bissau',
        cca2: 'GW',
        cca3: 'GNB',
        ccn3: 624
    },
    {
        country: 'Guyana',
        cca2: 'GY',
        cca3: 'GUY',
        ccn3: 328
    },
    {
        country: 'Haiti',
        cca2: 'HT',
        cca3: 'HTI',
        ccn3: 332
    },
    {
        country: 'Honduras',
        cca2: 'HN',
        cca3: 'HND',
        ccn3: 340
    },
    {
        country: 'Hong Kong',
        cca2: 'HK',
        cca3: 'HKG',
        ccn3: 344
    },
    {
        country: 'Hungary',
        cca2: 'HU',
        cca3: 'HUN',
        ccn3: 348
    },
    {
        country: 'Iceland',
        cca2: 'IS',
        cca3: 'ISL',
        ccn3: 352
    },
    {
        country: 'India',
        cca2: 'IN',
        cca3: 'IND',
        ccn3: 356
    },
    {
        country: 'Indonesia',
        cca2: 'ID',
        cca3: 'IDN',
        ccn3: 360
    },
    {
        country: 'Iran',
        cca2: 'IR',
        cca3: 'IRN',
        ccn3: 364
    },
    {
        country: 'Iraq',
        cca2: 'IQ',
        cca3: 'IRQ',
        ccn3: 368
    },
    {
        country: 'Ireland',
        cca2: 'IE',
        cca3: 'IRL',
        ccn3: 372
    },
    {
        country: 'Isle of Man',
        cca2: 'IM',
        cca3: 'IMN',
        ccn3: 833
    },
    {
        country: 'Israel',
        cca2: 'IL',
        cca3: 'ISR',
        ccn3: 376
    },
    {
        country: 'Italy',
        cca2: 'IT',
        cca3: 'ITA',
        ccn3: 380
    },
    {
        country: 'Ivory Coast',
        cca2: 'CI',
        cca3: 'CIV',
        ccn3: 384
    },
    {
        country: 'Jamaica',
        cca2: 'JM',
        cca3: 'JAM',
        ccn3: 388
    },
    {
        country: 'Japan',
        cca2: 'JP',
        cca3: 'JPN',
        ccn3: 392
    },
    {
        country: 'Jordan',
        cca2: 'JO',
        cca3: 'JOR',
        ccn3: 400
    },
    {
        country: 'Kazakhstan',
        cca2: 'KZ',
        cca3: 'KAZ',
        ccn3: 398
    },
    {
        country: 'Kenya',
        cca2: 'KE',
        cca3: 'KEN',
        ccn3: 404
    },
    {
        country: 'Kiribati',
        cca2: 'KI',
        cca3: 'KIR',
        ccn3: 296
    },
    {
        country: 'Kuwait',
        cca2: 'KW',
        cca3: 'KWT',
        ccn3: 414
    },
    {
        country: 'Kyrgyzstan',
        cca2: 'KG',
        cca3: 'KGZ',
        ccn3: 417
    },
    {
        country: 'Laos',
        cca2: 'LA',
        cca3: 'LAO',
        ccn3: 418
    },
    {
        country: 'Latvia',
        cca2: 'LV',
        cca3: 'LVA',
        ccn3: 428
    },
    {
        country: 'Lebanon',
        cca2: 'LB',
        cca3: 'LBN',
        ccn3: 422
    },
    {
        country: 'Lesotho',
        cca2: 'LS',
        cca3: 'LSO',
        ccn3: 426
    },
    {
        country: 'Liberia',
        cca2: 'LR',
        cca3: 'LBR',
        ccn3: 430
    },
    {
        country: 'Libya',
        cca2: 'LY',
        cca3: 'LBY',
        ccn3: 434
    },
    {
        country: 'Liechtenstein',
        cca2: 'LI',
        cca3: 'LIE',
        ccn3: 438
    },
    {
        country: 'Lithuania',
        cca2: 'LT',
        cca3: 'LTU',
        ccn3: 440
    },
    {
        country: 'Luxembourg',
        cca2: 'LU',
        cca3: 'LUX',
        ccn3: 442
    },
    {
        country: 'Macau',
        cca2: 'MO',
        cca3: 'MAC',
        ccn3: 446
    },
    {
        country: 'Madagascar',
        cca2: 'MG',
        cca3: 'MDG',
        ccn3: 450
    },
    {
        country: 'Malawi',
        cca2: 'MW',
        cca3: 'MWI',
        ccn3: 454
    },
    {
        country: 'Malaysia',
        cca2: 'MY',
        cca3: 'MYS',
        ccn3: 458
    },
    {
        country: 'Maldives',
        cca2: 'MV',
        cca3: 'MDV',
        ccn3: 462
    },
    {
        country: 'Mali',
        cca2: 'ML',
        cca3: 'MLI',
        ccn3: 466
    },
    {
        country: 'Malta',
        cca2: 'MT',
        cca3: 'MLT',
        ccn3: 470
    },
    {
        country: 'Marshall Islands',
        cca2: 'MH',
        cca3: 'MHL',
        ccn3: 584
    },
    {
        country: 'Martinique',
        cca2: 'MQ',
        cca3: 'MTQ',
        ccn3: 474
    },
    {
        country: 'Mauritania',
        cca2: 'MR',
        cca3: 'MRT',
        ccn3: 478
    },
    {
        country: 'Mauritius',
        cca2: 'MU',
        cca3: 'MUS',
        ccn3: 480
    },
    {
        country: 'Mayotte',
        cca2: 'YT',
        cca3: 'MYT',
        ccn3: 175
    },
    {
        country: 'Mexico',
        cca2: 'MX',
        cca3: 'MEX',
        ccn3: 484
    },
    {
        country: 'Micronesia',
        cca2: 'FM',
        cca3: 'FSM',
        ccn3: 583
    },
    {
        country: 'Moldova',
        cca2: 'MD',
        cca3: 'MDA',
        ccn3: 498
    },
    {
        country: 'Monaco',
        cca2: 'MC',
        cca3: 'MCO',
        ccn3: 492
    },
    {
        country: 'Mongolia',
        cca2: 'MN',
        cca3: 'MNG',
        ccn3: 496
    },
    {
        country: 'Montenegro',
        cca2: 'ME',
        cca3: 'MNE',
        ccn3: 499
    },
    {
        country: 'Montserrat',
        cca2: 'MS',
        cca3: 'MSR',
        ccn3: 500
    },
    {
        country: 'Morocco',
        cca2: 'MA',
        cca3: 'MAR',
        ccn3: 504
    },
    {
        country: 'Mozambique',
        cca2: 'MZ',
        cca3: 'MOZ',
        ccn3: 508
    },
    {
        country: 'Myanmar',
        cca2: 'MM',
        cca3: 'MMR',
        ccn3: 104
    },
    {
        country: 'Namibia',
        cca2: 'NA',
        cca3: 'NAM',
        ccn3: 516
    },
    {
        country: 'Nauru',
        cca2: 'NR',
        cca3: 'NRU',
        ccn3: 520
    },
    {
        country: 'Nepal',
        cca2: 'NP',
        cca3: 'NPL',
        ccn3: 524
    },
    {
        country: 'Netherlands',
        cca2: 'NL',
        cca3: 'NLD',
        ccn3: 528
    },
    {
        country: 'New Caledonia',
        cca2: 'NC',
        cca3: 'NCL',
        ccn3: 540
    },
    {
        country: 'New Zealand',
        cca2: 'NZ',
        cca3: 'NZL',
        ccn3: 554
    },
    {
        country: 'Nicaragua',
        cca2: 'NI',
        cca3: 'NIC',
        ccn3: 558
    },
    {
        country: 'Niger',
        cca2: 'NE',
        cca3: 'NER',
        ccn3: 562
    },
    {
        country: 'Nigeria',
        cca2: 'NG',
        cca3: 'NGA',
        ccn3: 566
    },
    {
        country: 'Niue',
        cca2: 'NU',
        cca3: 'NIU',
        ccn3: 570
    },
    {
        country: 'North Korea',
        cca2: 'KP',
        cca3: 'PRK',
        ccn3: 408
    },
    {
        country: 'North Macedonia',
        cca2: 'MK',
        cca3: 'MKD',
        ccn3: 807
    },
    {
        country: 'Northern Mariana Islands',
        cca2: 'MP',
        cca3: 'MNP',
        ccn3: 580
    },
    {
        country: 'Norway',
        cca2: 'NO',
        cca3: 'NOR',
        ccn3: 578
    },
    {
        country: 'Oman',
        cca2: 'OM',
        cca3: 'OMN',
        ccn3: 512
    },
    {
        country: 'Pakistan',
        cca2: 'PK',
        cca3: 'PAK',
        ccn3: 586
    },
    {
        country: 'Palau',
        cca2: 'PW',
        cca3: 'PLW',
        ccn3: 585
    },
    {
        country: 'Palestine',
        cca2: 'PS',
        cca3: 'PSE',
        ccn3: 275
    },
    {
        country: 'Panama',
        cca2: 'PA',
        cca3: 'PAN',
        ccn3: 591
    },
    {
        country: 'Papua New Guinea',
        cca2: 'PG',
        cca3: 'PNG',
        ccn3: 598
    },
    {
        country: 'Paraguay',
        cca2: 'PY',
        cca3: 'PRY',
        ccn3: 600
    },
    {
        country: 'Peru',
        cca2: 'PE',
        cca3: 'PER',
        ccn3: 604
    },
    {
        country: 'Philippines',
        cca2: 'PH',
        cca3: 'PHL',
        ccn3: 608
    },
    {
        country: 'Poland',
        cca2: 'PL',
        cca3: 'POL',
        ccn3: 616
    },
    {
        country: 'Portugal',
        cca2: 'PT',
        cca3: 'PRT',
        ccn3: 620
    },
    {
        country: 'Puerto Rico',
        cca2: 'PR',
        cca3: 'PRI',
        ccn3: 630
    },
    {
        country: 'Qatar',
        cca2: 'QA',
        cca3: 'QAT',
        ccn3: 634
    },
    {
        country: 'Republic of the Congo',
        cca2: 'CG',
        cca3: 'COG',
        ccn3: 178
    },
    {
        country: 'Reunion',
        cca2: 'RE',
        cca3: 'REU',
        ccn3: 638
    },
    {
        country: 'Romania',
        cca2: 'RO',
        cca3: 'ROU',
        ccn3: 642
    },
    {
        country: 'Russia',
        cca2: 'RU',
        cca3: 'RUS',
        ccn3: 643
    },
    {
        country: 'Rwanda',
        cca2: 'RW',
        cca3: 'RWA',
        ccn3: 646
    },
    {
        country: 'Saint Barthelemy',
        cca2: 'BL',
        cca3: 'BLM',
        ccn3: 652
    },
    {
        country: 'Saint Kitts and Nevis',
        cca2: 'KN',
        cca3: 'KNA',
        ccn3: 659
    },
    {
        country: 'Saint Lucia',
        cca2: 'LC',
        cca3: 'LCA',
        ccn3: 662
    },
    {
        country: 'Saint Martin',
        cca2: 'MF',
        cca3: 'MAF',
        ccn3: 663
    },
    {
        country: 'Saint Pierre and Miquelon',
        cca2: 'PM',
        cca3: 'SPM',
        ccn3: 666
    },
    {
        country: 'Saint Vincent and the Grenadines',
        cca2: 'VC',
        cca3: 'VCT',
        ccn3: 670
    },
    {
        country: 'Samoa',
        cca2: 'WS',
        cca3: 'WSM',
        ccn3: 882
    },
    {
        country: 'San Marino',
        cca2: 'SM',
        cca3: 'SMR',
        ccn3: 674
    },
    {
        country: 'Sao Tome and Principe',
        cca2: 'ST',
        cca3: 'STP',
        ccn3: 678
    },
    {
        country: 'Saudi Arabia',
        cca2: 'SA',
        cca3: 'SAU',
        ccn3: 682
    },
    {
        country: 'Senegal',
        cca2: 'SN',
        cca3: 'SEN',
        ccn3: 686
    },
    {
        country: 'Serbia',
        cca2: 'RS',
        cca3: 'SRB',
        ccn3: 688
    },
    {
        country: 'Seychelles',
        cca2: 'SC',
        cca3: 'SYC',
        ccn3: 690
    },
    {
        country: 'Sierra Leone',
        cca2: 'SL',
        cca3: 'SLE',
        ccn3: 694
    },
    {
        country: 'Singapore',
        cca2: 'SG',
        cca3: 'SGP',
        ccn3: 702
    },
    {
        country: 'Sint Maarten',
        cca2: 'SX',
        cca3: 'SXM',
        ccn3: 534
    },
    {
        country: 'Slovakia',
        cca2: 'SK',
        cca3: 'SVK',
        ccn3: 703
    },
    {
        country: 'Slovenia',
        cca2: 'SI',
        cca3: 'SVN',
        ccn3: 705
    },
    {
        country: 'Solomon Islands',
        cca2: 'SB',
        cca3: 'SLB',
        ccn3: 90
    },
    {
        country: 'Somalia',
        cca2: 'SO',
        cca3: 'SOM',
        ccn3: 706
    },
    {
        country: 'South Africa',
        cca2: 'ZA',
        cca3: 'ZAF',
        ccn3: 710
    },
    {
        country: 'South Korea',
        cca2: 'KR',
        cca3: 'KOR',
        ccn3: 410
    },
    {
        country: 'South Sudan',
        cca2: 'SS',
        cca3: 'SSD',
        ccn3: 728
    },
    {
        country: 'Spain',
        cca2: 'ES',
        cca3: 'ESP',
        ccn3: 724
    },
    {
        country: 'Sri Lanka',
        cca2: 'LK',
        cca3: 'LKA',
        ccn3: 144
    },
    {
        country: 'Sudan',
        cca2: 'SD',
        cca3: 'SDN',
        ccn3: 729
    },
    {
        country: 'Suriname',
        cca2: 'SR',
        cca3: 'SUR',
        ccn3: 740
    },
    {
        country: 'Sweden',
        cca2: 'SE',
        cca3: 'SWE',
        ccn3: 752
    },
    {
        country: 'Switzerland',
        cca2: 'CH',
        cca3: 'CHE',
        ccn3: 756
    },
    {
        country: 'Syria',
        cca2: 'SY',
        cca3: 'SYR',
        ccn3: 760
    },
    {
        country: 'Taiwan',
        cca2: 'TW',
        cca3: 'TWN',
        ccn3: 158
    },
    {
        country: 'Tajikistan',
        cca2: 'TJ',
        cca3: 'TJK',
        ccn3: 762
    },
    {
        country: 'Tanzania',
        cca2: 'TZ',
        cca3: 'TZA',
        ccn3: 834
    },
    {
        country: 'Thailand',
        cca2: 'TH',
        cca3: 'THA',
        ccn3: 764
    },
    {
        country: 'Timor-Leste',
        cca2: 'TL',
        cca3: 'TLS',
        ccn3: 626
    },
    {
        country: 'Togo',
        cca2: 'TG',
        cca3: 'TGO',
        ccn3: 768
    },
    {
        country: 'Tokelau',
        cca2: 'TK',
        cca3: 'TKL',
        ccn3: 772
    },
    {
        country: 'Tonga',
        cca2: 'TO',
        cca3: 'TON',
        ccn3: 776
    },
    {
        country: 'Trinidad and Tobago',
        cca2: 'TT',
        cca3: 'TTO',
        ccn3: 780
    },
    {
        country: 'Tunisia',
        cca2: 'TN',
        cca3: 'TUN',
        ccn3: 788
    },
    {
        country: 'Turkey',
        cca2: 'TR',
        cca3: 'TUR',
        ccn3: 792
    },
    {
        country: 'Turkmenistan',
        cca2: 'TM',
        cca3: 'TKM',
        ccn3: 795
    },
    {
        country: 'Turks and Caicos Islands',
        cca2: 'TC',
        cca3: 'TCA',
        ccn3: 796
    },
    {
        country: 'Tuvalu',
        cca2: 'TV',
        cca3: 'TUV',
        ccn3: 798
    },
    {
        country: 'Uganda',
        cca2: 'UG',
        cca3: 'UGA',
        ccn3: 800
    },
    {
        country: 'Ukraine',
        cca2: 'UA',
        cca3: 'UKR',
        ccn3: 804
    },
    {
        country: 'United Arab Emirates',
        cca2: 'AE',
        cca3: 'ARE',
        ccn3: 784
    },
    {
        country: 'United Kingdom',
        cca2: 'GB',
        cca3: 'GBR',
        ccn3: 826
    },
    // {
    //     country: 'United States',
    //     cca2: 'US',
    //     cca3: 'USA',
    //     ccn3: 840
    // },
    {
        country: 'United States Virgin Islands',
        cca2: 'VI',
        cca3: 'VIR',
        ccn3: 850
    },
    {
        country: 'Uruguay',
        cca2: 'UY',
        cca3: 'URY',
        ccn3: 858
    },
    {
        country: 'Uzbekistan',
        cca2: 'UZ',
        cca3: 'UZB',
        ccn3: 860
    },
    {
        country: 'Vanuatu',
        cca2: 'VU',
        cca3: 'VUT',
        ccn3: 548
    },
    {
        country: 'Vatican City',
        cca2: 'VA',
        cca3: 'VAT',
        ccn3: 336
    },
    {
        country: 'Venezuela',
        cca2: 'VE',
        cca3: 'VEN',
        ccn3: 862
    },
    {
        country: 'Vietnam',
        cca2: 'VN',
        cca3: 'VNM',
        ccn3: 704
    },
    {
        country: 'Wallis and Futuna',
        cca2: 'WF',
        cca3: 'WLF',
        ccn3: 876
    },
    {
        country: 'Western Sahara',
        cca2: 'EH',
        cca3: 'ESH',
        ccn3: 732
    },
    {
        country: 'Yemen',
        cca2: 'YE',
        cca3: 'YEM',
        ccn3: 887
    },
    {
        country: 'Zambia',
        cca2: 'ZM',
        cca3: 'ZMB',
        ccn3: 894
    },
    {
        country: 'Zimbabwe',
        cca2: 'ZW',
        cca3: 'ZWE',
        ccn3: 716
    }
];
